import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * 加载指示器组件的属性
 */
interface LoadingIndicatorProps {
  /** 是否全屏显示 */
  fullPage?: boolean;
  /** 加载提示文字 */
  message?: string;
}

/**
 * 加载指示器组件
 *
 * 用于显示加载状态，支持全屏居中和内联两种模式。
 *
 * @example
 * // 内联加载
 * <LoadingIndicator message="加载中..." />
 *
 * @example
 * // 全屏加载
 * <LoadingIndicator fullPage message="正在处理，请稍候..." />
 */
export function LoadingIndicator({ fullPage = false, message }: LoadingIndicatorProps) {
  if (fullPage) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
        }}
      >
        <CircularProgress size={48} />
        {message && (
          <Typography sx={{ mt: 2 }} color="text.secondary">
            {message}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
      }}
    >
      <CircularProgress />
      {message && (
        <Typography sx={{ mt: 2 }} color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
}
